export default "__VITE_ASSET__2f33f1ec__"